import { BrowserRouter } from "react-router-dom";
import Header from "./components/header/Header";
import Main from "./components/Main";
import { AppProvider } from "./AppContext"; // ⬅️ import the context provider

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Header />
        <Main />
      </BrowserRouter>
    </AppProvider>
  );
}
